module.exports = __webpack_public_path__ + "media/images/emblems/Corbieres_FR-coat_of_arms-b89de48b1f8f23a5a640da9566c0cffa.svg";